// extracted by mini-css-extract-plugin
module.exports = {"uploadWrap":"ImageMultiUpload_uploadWrap__3KdtD","uploadItem":"ImageMultiUpload_uploadItem__3Mgfo"};